var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfEmploymentTaxCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#EAEAF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.133 19.297C18.133 19.2037 18.1723 19.1142 18.2424 19.0483C18.3124 18.9823 18.4073 18.9453 18.5064 18.9453H21.4932C21.5922 18.9453 21.6871 18.9823 21.7572 19.0483C21.8272 19.1142 21.8665 19.2037 21.8665 19.297C21.8665 19.3902 21.8272 19.4797 21.7572 19.5457C21.6871 19.6116 21.5922 19.6487 21.4932 19.6487H18.5064C18.4073 19.6487 18.3124 19.6116 18.2424 19.5457C18.1723 19.4797 18.133 19.3902 18.133 19.297ZM29.3335 15.7799V27.0345C29.3335 27.3143 29.2155 27.5827 29.0055 27.7806C28.7954 27.9785 28.5105 28.0896 28.2135 28.0896H11.7861C11.489 28.0896 11.2041 27.9785 10.9941 27.7806C10.784 27.5827 10.666 27.3143 10.666 27.0345V15.7799C10.666 15.5001 10.784 15.2317 10.9941 15.0338C11.2041 14.8359 11.489 14.7248 11.7861 14.7248H15.8929V13.6697C15.8929 13.2033 16.0896 12.756 16.4397 12.4262C16.7898 12.0964 17.2646 11.9111 17.7597 11.9111H22.2399C22.735 11.9111 23.2098 12.0964 23.5599 12.4262C23.9099 12.756 24.1066 13.2033 24.1066 13.6697V14.7248H28.2135C28.5105 14.7248 28.7954 14.8359 29.0055 15.0338C29.2155 15.2317 29.3335 15.5001 29.3335 15.7799ZM16.6396 14.7248H23.3599V13.6697C23.3599 13.3898 23.2419 13.1215 23.0319 12.9236C22.8218 12.7257 22.5369 12.6145 22.2399 12.6145H17.7597C17.4626 12.6145 17.1777 12.7257 16.9677 12.9236C16.7576 13.1215 16.6396 13.3898 16.6396 13.6697V14.7248ZM11.4127 15.7799V19.6487C14.0358 21.0336 16.9928 21.7602 19.9998 21.7589C23.0068 21.7602 25.9637 21.0336 28.5868 19.6487V15.7799C28.5868 15.6866 28.5475 15.5972 28.4775 15.5312C28.4074 15.4653 28.3125 15.4282 28.2135 15.4282H11.7861C11.687 15.4282 11.5921 15.4653 11.5221 15.5312C11.4521 15.5972 11.4127 15.6866 11.4127 15.7799ZM28.5868 27.0345V20.4488C25.9424 21.7716 22.9939 22.463 19.9998 22.4623C17.0056 22.4632 14.057 21.7718 11.4127 20.4488V27.0345C11.4127 27.1278 11.4521 27.2172 11.5221 27.2832C11.5921 27.3492 11.687 27.3862 11.7861 27.3862H28.2135C28.3125 27.3862 28.4074 27.3492 28.4775 27.2832C28.5475 27.2172 28.5868 27.1278 28.5868 27.0345Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.525
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfEmploymentTaxCalculator);
export default __webpack_public_path__ + "static/media/self-employment-tax-calculator.d842b1476afb9b82a41077386d15f540.svg";
export { ForwardRef as ReactComponent };